/** @format */

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
// import { Manager, Target, Popper } from "react-popper";
import {Auth} from '../../modules/auth/Auth';
import {history} from '../../core/history';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';
import Grow from '@material-ui/core/Grow';
import Hidden from '@material-ui/core/Hidden';
import Popper from '@material-ui/core/Popper';

// @material-ui/icons
import Person from '@material-ui/icons/Person';
// import Notifications from "@material-ui/icons/Notifications";
// import Dashboard from "@material-ui/icons/Dashboard";
// import Search from "@material-ui/icons/Search";
// core components
// import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from 'components/CustomButtons/Button.jsx';

import adminNavbarLinksStyle from 'assets/jss/material-dashboard-pro-react/components/adminNavbarLinksStyle.jsx';
import PasswordChangeModal from '../../views/Pages/PasswordChangeModal';
import {authActions} from '../../modules/auth/actions';
import compose from 'recompose/compose';
import {connect} from 'react-redux';
import I18n from '../Translate/I18n';
import DiscardCertificationModal from '../../views/Pages/DiscardCertificationModal';
import {ItemLoaders} from '../../core/loaders/ItemLoaders';
import {FormGeneralHelper} from '../../helpers/FormGeneral';
import {configDefault} from '../../core/config';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';
import COLORS from "../../assets/themes/OPL/colors";
import LanguageSelect from "../Translate/LanguageSelect";

class HeaderLinks extends React.Component {
    state = {
        open: false,
        userMenu: false,
    };
    handleClick = () => {
        this.setState({open: !this.state.open});
    };
    handleClose = () => {
        this.setState({open: false});
    };
    handleUserClick = () => {
        this.setState({userMenu: !this.state.userMenu});
    };
    handleUserClose = () => {
        this.setState({userMenu: false});
    };

    handleUserLogout = () => {
        const {dispatch} = this.props;
        const itemLoader = new ItemLoaders(dispatch);
        itemLoader.deleteCall(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/refresh_tokens/' + 1, configDefault.PLATFORM_API_PREFIX)),
            'refresh_token_delete',
            (data) => {
            }
        );
        Auth.clearToken();
        history.push(process.env.REACT_APP_LOGIN_PAGE);
    };

    handleChangePassword = () => {
        const {dispatch} = this.props;

        if (Auth.usedSingleUsePassword() && !Auth.usedKerberos() && Auth.isDefinitelyGenericUser()) {
            dispatch({
                type: authActions.TOGGLE_MODAL,
                passwordModalOpen: true,
                disableModalClose: true,
                modalModifiedSubTitle: 'auth:login_page.used_single_use_password',
            });
        } else {
            dispatch({type: authActions.TOGGLE_MODAL, passwordModalOpen: true});
        }
    };

    handleDiscardCertificates = () => {
        const {dispatch} = this.props;

        if (Auth.isGenericUser()) {
            dispatch({type: authActions.TOGGLE_MODAL, certificationModalOpen: true});
        }
    };

    render() {
        const {classes, rtlActive} = this.props;
        const {userMenu} = this.state;
        // const searchButton =
        //     classes.top +
        //     " " +
        //     classes.searchButton +
        //     " " +
        //     classNames({
        //         [classes.searchRTL]: rtlActive
        //     });
        const dropdownItem = classNames(classes.dropdownItem, classes.primaryHover, {[classes.dropdownItemRTL]: rtlActive});
        const wrapper = classNames({
            [classes.wrapperRTL]: rtlActive,
        });
        // const managerClasses = classNames({
        //     [classes.managerClasses]: true
        // });
        return (
            <div className={wrapper}>
                <Button
                    color="transparent"
                    aria-label="Person"
                    buttonRef={(node) => {
                        this.anchorEl = node;
                    }}
                    justIcon
                    className={classes.buttonLink}
                    aria-owns={userMenu ? 'menu-list' : null}
                    aria-haspopup="true"
                    onClick={this.handleUserClick}
                >
                    <Person className={classes.headerLinksSvg + ' ' + classes.links} style={{marginTop: 10}}/>
                    <Hidden mdUp implementation="css">
                        <span onClick={this.handleUserClick} className={classes.linkText}>
                            {'Profile'}
                        </span>
                    </Hidden>
                    <Popper
                        open={userMenu}
                        anchorEl={this.anchorEl}
                        transition
                        placement="bottom"
                        className={classNames({
                            [classes.popperClose]: !userMenu,
                            [classes.pooperResponsive]: true,
                            [classes.pooperNav]: true,
                        })}
                    >
                        {({TransitionProps, placement}) => (
                            <Grow {...TransitionProps} id="menu-list" style={{transformOrigin: '0 0 0'}}>
                                <Paper className={classes.dropdown}
                                       style={{boxShadow: 'rgb(66, 68, 90) 0px 6px 32px -6px'}} elevation={0}>
                                    <ClickAwayListener onClickAway={this.handleClose}>
                                        <MenuList role="menu">
                                            {/*<MenuItem onClick={this.handleUserLogout} className={dropdownItem}>*/}
                                            {/*    {'Setup'}*/}
                                            {/*</MenuItem>*/}
                                            <MenuItem onClick={this.handleChangePassword}
                                                      style={{
                                                          fontSize: '0.875rem',
                                                          fontWeight: 400,
                                                          lineHeight: 1.43,
                                                          borderBottom: `1px solid ${COLORS.ADDITIONAL.ADDITIONAL_DARK}`
                                                      }}>
                                                <I18n trans={'auth:password_change.change_password'}/>
                                            </MenuItem>
                                            {Auth.isGenericUser() && (
                                                <MenuItem onClick={this.handleDiscardCertificates}
                                                          style={{
                                                              fontSize: '0.875rem',
                                                              fontWeight: 400,
                                                              lineHeight: 1.43,
                                                              borderBottom: `1px solid ${COLORS.ADDITIONAL.ADDITIONAL_DARK}`
                                                          }}>
                                                    <I18n trans={'auth:certificate.discard_your_certificates'}/>
                                                </MenuItem>
                                            )}
                                            <MenuItem onClick={this.handleUserLogout} style={{
                                                fontSize: '0.875rem',
                                                fontWeight: 400,
                                                lineHeight: 1.43,
                                                borderBottom: `1px solid ${COLORS.ADDITIONAL.ADDITIONAL_DARK}`
                                            }}>
                                                <I18n trans={'auth:login_page.logout'}/>
                                            </MenuItem>
                                            <div style={{
                                                fontSize: '0.875rem',
                                                margin: 4,
                                                fontWeight: 400,
                                                lineHeight: 1.43,
                                                display: 'flex',
                                                justifyContent: 'center'
                                            }}>
                                                <LanguageSelect/>
                                            </div>
                                        </MenuList>
                                    </ClickAwayListener>
                                </Paper>
                            </Grow>
                        )}
                    </Popper>
                </Button>
                <PasswordChangeModal/>
                <DiscardCertificationModal/>
            </div>
        );
    }
}

HeaderLinks.propTypes = {
    classes: PropTypes.object.isRequired,
    rtlActive: PropTypes.bool,
};

export default compose(connect(), withStyles(oplAppStyle))(HeaderLinks);
